/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class TopicOperationsIcon extends BaseIcon {
  getChildren = () => [ <path d="M21,4H3A1,1,0,0,0,2,5V20a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V5A1,1,0,0,0,21,4ZM19.37,14.77a.71.71,0,0,1-.57.24.68.68,0,0,1-.57-.24L16.4,12.44l-3.29,6.29a.74.74,0,0,1-.67.26c-.3,0-.52-.18-.55-.36l-1-9.46L8.73,14.7a.63.63,0,0,1-.57.3.69.69,0,0,1-.62-.26L6,12.13,4.18,13.29a.27.27,0,0,1-.18,0l1.79-2.22A.88.88,0,0,1,6.38,11a.6.6,0,0,1,.45.26l1.18,2L10.66,6.5a.61.61,0,0,1,.54-.3.9.9,0,0,1,.47.09.41.41,0,0,1,.22.29l1,10,2.77-5.28a.65.65,0,0,1,.55-.27.72.72,0,0,1,.6.23L18.8,13.7l.68-.87c.1-.13.3-.2.52.9Z" fill={this.getColor()}/> ]
  getViewBox = () => '0 0 24 24'
}
